///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportInventoryReturns = Meevo.Plugins.Reports.IReportInventoryReturns;

    export class ReportInventoryReturnsCollection extends SmartMoverApiCollection<IReportInventoryReturns> implements IApiCollection<IReportInventoryReturns> {

        protected get url() {
            return 'report/InventoryReturn';
        }

        protected criteriaIsValid() {
            return typeof this.criteria['InventoryReturnsEndDate'] === 'object'
                && typeof this.criteria['InventoryReturnsStartDate'] === 'object';
        }
    }

}